import PageLeaderboard from './PageLeaderboard';
import { connect } from 'react-redux';
import { AppState } from '../../interfaces';
import { getLeaderboard } from '../../actions/leaderboard';
import { setMeta } from '../../actions';

const mapStateToProps = (state: AppState) => ({
  leaderboard: state.leaderboardReducer,
  listLocation: state.listLocationReducer,
});
const mapDispatchToProps = (dispatch) => ({
  getLeaderboard: (propertyId) => dispatch(getLeaderboard(propertyId)),
  setMeta: (propertyId) => dispatch(setMeta(propertyId)),
});
export default connect(mapStateToProps, mapDispatchToProps)(PageLeaderboard);
